import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=1100fb8d&"
import script from "./reset-password.ts?vue&type=script&lang=ts&"
export * from "./reset-password.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports